import DateHelper from "~/ts/library/Date";

export default function getCurrentVisitTime(userdata?: OperatorApplicationApi.OperatorApplicationClientOpenApiModel) {
    if (userdata) {
        let lastVisitStartDateTime: DateHelper = null;
        if (userdata.visitStatistic) {
            lastVisitStartDateTime = new DateHelper(userdata.visitStatistic.lastVisitStartDateTime * 1000);
        }

        let stop = userdata.visitStatistic.lastVisitStopDateTime;

        let lastVisitStopDateTime = new DateHelper(stop ? stop * 1000 : DateHelper.now);

        if (lastVisitStartDateTime) {
            let result = Math.ceil(
                (lastVisitStopDateTime.dateObject.getTime() - lastVisitStartDateTime.dateObject.getTime()) / 1000
            );
            if (result > 0) {
                return result;
            }
        }
    }
    return 0;
}